import { render, staticRenderFns } from "./HelpArticlesDetailsComponent.vue?vue&type=template&id=57240089&scoped=true&"
import script from "./HelpArticlesDetailsComponent.vue?vue&type=script&lang=js&"
export * from "./HelpArticlesDetailsComponent.vue?vue&type=script&lang=js&"
import style0 from "./HelpArticlesDetailsComponent.vue?vue&type=style&index=0&id=57240089&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57240089",
  null
  
)

export default component.exports